export default "__VITE_ASSET__f2269292__"